<template>
  <b-container>
    <b-row>
      <b-col>
        <b-card>
          <h1 class="mb-0">Dashboard User</h1>
        </b-card>
      </b-col>
    </b-row>
    <campaigns-statistics/>
    <websites-visitors/>
  </b-container>
</template>
<script>
import { BContainer, BRow, BCol, BCard } from "bootstrap-vue";
import websitesVisitors from "../settings/analytics/websitesVisitors.vue";
import campaignsStatistics from "../ads-manager/analytics/campaigns-statistics.vue";
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    websitesVisitors,
    campaignsStatistics
  },
  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("userData")) {
      const role = JSON.parse(localStorage.getItem("userData")).role;
      if (role === "user") {
        next(true);
      } else {
        next("/error-404");
      }
    }else{
      next("/error-404");
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
.links {
  color: inherit;
}
</style>
